import { forwardRef } from "react";
import { Checkbox, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { getObjValueFromPath } from "utils";
import { Controller } from "react-hook-form";

function FormCheckBox(
  { label ,isDisabled, name, id = name, errors, control, controlProps, size = "md"}, ref
) {
  const error = getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      maxInlineSize={{ base: "full", lg: "lg" }}
      minInlineSize="0"
      {...controlProps}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field: { value, ...field } }) => (
          <Checkbox
            isDisabled={isDisabled}
            colorScheme={"customScheme"}
            ref={ref}
            {...field}
            isChecked={!!value}
            color="primary"
            marginBlockStart={1}
            size={size}
          >
            {label}
          </Checkbox>
        )}
      />
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormCheckBox);
